import { Reaction, ReactionId, ReactionsEnum } from '../../timeline-item.types';

export type EmoticonReaction = Reaction & {
  label: string;
  smiley?: string;
  icon?: string;
}


export type EmoticonReactionDef = {
  id: ReactionId;
  label: string;
  smiley?: string;
  icon?: string;
}

export const EMOTICON_REACTION_DEFS: Map<ReactionId, EmoticonReactionDef> = new Map<ReactionsEnum, EmoticonReactionDef>([
  [
    ReactionsEnum.care,
    {
      id: 'care',
      label: 'bad-mood-streak.care',
      icon: 'fa-solid fa-hand-holding-heart'
    }
  ], [
    ReactionsEnum.love,
    {
      id: 'love',
      label: 'reaction.love',
      smiley: '😍',
    }
  ], [
    ReactionsEnum.laugh,
    {
      id: 'laugh',
      label: 'reaction.laugh',
      smiley: '😂',
    }
  ], [
    ReactionsEnum.surprise,
    {
      id: 'surprise',
      label: 'reaction.surprise',
      smiley: '😯',
    }
  ], [
    ReactionsEnum.thinking,
    {
      id: 'thinking',
      label: 'reaction.thinking',
      smiley: '🤔',
    }
  ], [
    ReactionsEnum.sad,
    {
      id: 'sad',
      label: 'reaction.sad',
      smiley: '😢',
    }
  ], [
    ReactionsEnum.agree,
    {
      id: 'agree',
      label: 'comment-card.agree',
      smiley: '👍',
    }
  ], [
    ReactionsEnum.disagree,
    {
      id: 'disagree',
      label: 'comment-card.disagree',
      smiley: '👎',
    }
  ],
])